import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

/**
 * Route is the pathless _onboarding layout: a full-screen authenticated frame for the
 * create-organization flow, with no app shell or sidebar so it owns the whole screen. Its
 * beforeLoad is the same auth guard the _app shell applies — an anonymous user (no session
 * on the router context, which the root beforeLoad resolved) is redirected to /login with a
 * return_to so they land back here after signing in. It deliberately skips the _app shell's
 * org-membership prefetch: the onboarding flow is where a user creates their first
 * organization, so there is no membership yet whose studio_entitlements the shell would read
 * (ADR 0104). The leading
 * underscore keeps /_onboarding out of the URL. The child route wraps its content in the
 * shared AuthShell itself, so it can thread the page-corner close affordance (present only
 * for the in-app create) straight into the shell.
 */
export const Route = createFileRoute("/_onboarding")({
  beforeLoad: ({ context, location }) => {
    if (!context.session) {
      throw redirect({ search: { return_to: location.href }, to: "/login" });
    }
  },
  component: OnboardingLayout,
});

function OnboardingLayout() {
  return <Outlet />;
}
